import type { PropType } from 'virtual-vue';
import type { FormRule, FormTrigger, FormLayout, FormLabelAlign } from './types';

export const formItemProps = {
  /**
   * 字段名（对应 model 中的 key）
   */
  name: {
    type: String,
  },

  /**
   * 标签文本
   */
  label: {
    type: String,
    default: '',
  },

  /**
   * 标签宽度（覆盖 Form 设置）
   */
  labelWidth: {
    type: [String, Number] as PropType<string | number>,
  },

  /**
   * 标签对齐（覆盖 Form 设置）
   */
  labelAlign: {
    type: String as PropType<FormLabelAlign>,
  },

  /**
   * 布局方式（覆盖 Form 设置）
   */
  layout: {
    type: String as PropType<FormLayout>,
  },

  /**
   * 小标题文本
   */
  subtitle: {
    type: String,
    default: '',
  },

  /**
   * 辅助说明文本
   */
  tips: {
    type: String,
    default: '',
  },

  /**
   * 字段校验规则
   */
  rules: {
    type: Array as PropType<FormRule[]>,
  },

  /**
   * 字段级校验触发时机
   */
  validateTrigger: {
    type: [String, Array] as PropType<FormTrigger | FormTrigger[]>,
  },

  /**
   * 是否显示必填标记
   * @default false
   */
  required: {
    type: Boolean,
    default: false,
  },

  /**
   * 手动控制错误状态，未传时由自动校验控制
   */
  error: {
    type: [Boolean, null] as PropType<boolean | null>,
    default: null,
  },

  /**
   * 手动指定错误文案
   */
  errorMessage: {
    type: String,
  },

  /**
   * 是否显示错误文案，未传时继承 Form.showErrorMessage
   */
  showErrorMessage: {
    type: [Boolean, null] as PropType<boolean | null>,
    default: null,
  },

  /**
   * 是否禁用，未传时继承 Form.disabled
   */
  disabled: {
    type: [Boolean, null] as PropType<boolean | null>,
    default: null,
  },

  /**
   * 是否显示底部边框线
   * @default true
   */
  bordered: {
    type: Boolean,
    default: true,
  },
};
